<template>
    <div class="lby-task-item" @click="taskInfo">
      <div class="lby-task-detail task-type">任务类型:{{taskType}}</div>
      <div class="lby-task-detail price">任务价格:{{task.price}}￥</div>
      <div class="lby-task-detail">任务描述:{{task.description}}</div>
      <div class="lby-gossip-createTime">更新:{{task.updateTime}}</div>
    </div>
  </template>

<script>
export default {
  name: 'UCTask',
  props: {
    task: {
      default: () => {
        return {}
      }
    },
    pageNo: {
      type: Number,
      default: 1
    }
  },
  methods: {
    taskInfo () {
      this.$router.push({
        path: '/taskinfo',
        query: {
          taskId: this.task.id,
          taskPageNo: this.pageNo
        }
      })
    }
  },
  computed: {
    taskType () {
      if (this.$store.state.basicdata.taskTypeList.find(item => item.id === this.task.taskType) == null) {
        return '未知类型'
      }
      return this.$store.state.basicdata.taskTypeList.find(item => item.id === this.task.taskType).description
    }
  }
}
</script>

  <style scoped lang="less">
  .lby-task-item{
      width: 150px;
      height: 100%;
      border-radius: 10px;
      border: 1px solid #409eff;
      box-shadow: 0 0 4px rgb(53, 52, 52);
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      .lby-task-detail{
        padding-left: 10px;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .price{
        color:rgb(248, 81, 4);
        font-size:13px
      }
      .task-type{
        color:rgb(5, 66, 235);
        font-size:13px
      }
  }
  .lby-task-item:hover{
      border-color: red;
      cursor: pointer;
  }
  </style>
